/**
 * Smooth Scroll zurück zum Seitenanfang.
 * Erwartet ein Element mit id="scrollToTopBtn".
 */
export function scrollToTop() {
	const btn = document.getElementById('scrollToTopBtn')
	if (!btn) return

	btn.addEventListener('click', () => {
		document.documentElement.scrollTo({
			top: 0,
			behavior: 'smooth'
		})
	})
}
